/* eslint-disable react/prop-types */
import { Delete } from "lucide-react";

const RemoveButton = ({ onClick, className = "" }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Backspace"
      className={`
        w-16 h-16 sm:w-[72px] sm:h-[72px] rounded-2xl
        flex items-center justify-center 
        cursor-pointer select-none
        bg-red-500/20 border border-red-500/40 text-red-300
        hover:bg-red-500/30 hover:border-red-400/70 hover:text-red-200 
        hover:shadow-[0_0_15px_rgba(239,68,68,0.25)]
        active:scale-95 active:bg-red-500/40
        backdrop-blur-sm transition-all duration-150 shadow-sm
        ${className}
      `}
    >
      <Delete size={26} strokeWidth={2.2} />
    </button>
  );
};

export default RemoveButton;
